// -----------------------------------------------------------------------------------------------------------------
// Imports
// -----------------------------------------------------------------------------------------------------------------
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'

// -----------------------------------------------------------------------------------------------------------------
// Services
// -----------------------------------------------------------------------------------------------------------------
@Injectable()
export class UsersService {
  private API_ENDPOINT = `${environment.HOST}/adminapi`
  private API2_ENDPOINT = `${environment.HOST}/api2.0`

  constructor(private http: HttpClient) { }

  // -----------------------------------------------------------------------------------------------------------------
  // Functions to fetch data
  // -----------------------------------------------------------------------------------------------------------------
  public searchUsers = (searchTerm: string) => {
    return this.http.get(`${this.API_ENDPOINT}/users/searchusers/searchTerm/${searchTerm}`)
  }

  public getUser = (userId: any) => {
    return this.http.get(`${this.API_ENDPOINT}/users/getuser/userId/${userId}`)
  }

  public getLevels = (trialId: any, sourceId: any) => {
    return this.http.get(`${this.API2_ENDPOINT}/general/getlevel/trial_id/${trialId}/source_id/${sourceId}`)
  }

  public getGroups = (sourceId: any) => {
    return this.http.get(`${this.API2_ENDPOINT}/general/getstoregroups/source_id/${sourceId}`)
  }

  public findDevicesLogs = (userId: any) => {
    return this.http.get(`${this.API_ENDPOINT}/users/findlogs/user_id/${userId}`)
  }

  public getDevicesLogs = (userId: any) => {
    return this.http.get(`${this.API_ENDPOINT}/users/getioslogs/user_id/${userId}`)
  }

  // -----------------------------------------------------------------------------------------------------------------
  // Functions to save changes
  // -----------------------------------------------------------------------------------------------------------------
  public userUpdate = (user: any) => {
    return this.http.post(`${this.API_ENDPOINT}/users/edituser`, { user })
  }

  public addMembership = (membershipSource: any, membershipSplitGroup: any, membershipLevel: any, userId: any) => {
    const formData: FormData = new FormData()
    formData.append('membershipsource', membershipSource)
    formData.append('membershipsplitgroup', membershipSplitGroup)
    formData.append('membershiplevel', membershipLevel)
    formData.append('user_id', userId)

    return this.http.post(`${this.API_ENDPOINT}/users/addmembership`, formData)
  }

  public changeActiveMembership = (newId: any, userId: any) => {
    const formData: FormData = new FormData()
    formData.append('new_id', newId)
    formData.append('user_id', userId)

    return this.http.post(`${this.API_ENDPOINT}/users/changeactivemembership`, formData)
  }

  public addProgram = (programSource: any, program: any, orderId: any, userId: any) => {
    const formData: FormData = new FormData()
    formData.append('programsource', programSource)
    formData.append('program', program)
    formData.append('order_id', orderId)
    formData.append('user_id', userId)

    return this.http.post(`${this.API_ENDPOINT}/users/addprogram`, formData)
  }

  // -----------------------------------------------------------------------------------------------------------------
  // Functions to delete
  // -----------------------------------------------------------------------------------------------------------------
  public deleteUser = (userId: any) => {
    return this.http.get(`${this.API_ENDPOINT}/users/deleteuser/userId/${userId}`)
  }

  public deleteMembership = (membershipId: any, userId: any) => {
    return this.http.get(`${this.API_ENDPOINT}/users/deletemembership/id/${membershipId}/userId/${userId}`)
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/users.service.ts